import Link from "next/link";
import BlogCard from "./blog-card";
import { SectionHeader } from "./landing/landing-ui";

export const HOME_BLOG_LIMIT = 3;

/**
 * Renders the "From the field" teaser. Posts are supplied by the page's
 * getStaticProps so the article links exist in the server-rendered HTML.
 */
const AiBlog = ({ posts = [] }) => {
  if (!posts.length) return null;

  return (
    <section className="landing-section landing-section-muted">
      <div className="container max-w-7xl">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <SectionHeader
            align="left"
            title="From the field"
            lead="Practical notes on agents, LLM applications, and automation from production work."
            className="md:max-w-2xl"
          />
          <Link
            href="/blogs"
            className="inline-flex shrink-0 items-center justify-center rounded-full border border-[#1c8c80] bg-surface px-5 py-2.5 text-ink no-underline transition-colors hover:bg-[#1c8c80] hover:text-white"
          >
            View all articles
          </Link>
        </div>

        <div className="-m-3 mt-10 flex flex-wrap items-stretch justify-center">
          {posts.map((post) => (
            <div key={post.slug} className="col-12 flex md:col-6 lg:col-4">
              <BlogCard blog={post} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AiBlog;
